import React,{useState} from "react";
// reactstrap components
import { Card, CardHeader, CardBody, Row, Col, FormGroup, Button, Input, Table} from "reactstrap";
import {calcSeller,receiveDeposit,depositList} from 'network/ApiAxiosTickets'
import SellerDropdown from "./SellerDropdown";
//import Table from "reactstrap/lib/Table";
import { v4 as uuid } from 'uuid';
import DepositLogs from "./DepositLogs";

const DepositCard = (props) => {
  const [total, setTotal] = useState();
  const [sellerIdd, setSellerIdd] = useState("");
  const [eventList, setEventList] = useState();

  const role = JSON.parse(localStorage.getItem('user')).role

  const handleSeller = async(sellerID)=>{
    getTotal(sellerID)
    //displayEvents(sellerID)
    setSellerIdd(sellerID)

/*
    if(id!="1"||id!=""){
      setSellerId(id)
      console.log(id)
      const resp = await calcSeller(id)
      const respEvents = await depositList(sellerId)
      setEventList(resp.data.result)
      console.log(eventList)
      if(resp.data.success){
        setTotal(resp.data)
        displayEvents()
      }
      
    }else{
      setTotal()
    }
    */
  }

  const getTotal = async(sellerID)=>{
    const resp = await calcSeller(sellerID)
    if(resp.data.success) setTotal(resp.data)
  }

  /*
  const displayEvents = async(sellerID)=>{
      const resp = await depositList(sellerID)
      if(resp.data.success) setEventList(resp.data.result)
  }
      */

  const handleReceive = async ()=>{
    const {data} = await receiveDeposit(sellerIdd)
    if(data.success){
      handleSeller(sellerIdd)
    }
  }
   
    return (
          <>
            <Col className="mb-2" xs="auto" xl="12" >
              <Card className="shadow">
                <CardHeader className="border-0">
                  <Row className="align-items-center text-center">
                    <Col xs="12">
                      <h3 className="mb-0" > Choose Seller </h3>
                      <FormGroup>
                        {/*<Input type="select" onChange={(e)=>handleSeller(e.target.value)} >
                          {sellers ? <option key="choose" value='1' label='Choose a Seller' />:
                          <option key='Loading...' value='1' label='Loading...' />}
                          {sellers && sellers.map((seller)=>{
                            return <option key={seller._id} value={seller._id} label={seller.name} />
                          })
                        </Input>}*/}
                        <SellerDropdown handler={(id)=>handleSeller(id)} />
                      </FormGroup>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody className="align-self-center text-center"  >
                  <Row>
                    <h3 className="mr-2">Total:{total ? total.total : "Loading..."} </h3>
                  </Row>
                  <Row>
                    {total && total.total>0 && 
                  <Button className="btn-default" onClick={handleReceive} >
                    <i className='ni ni-credit-card text-white mr-1' /> 
                    Receive Deposits
                  </Button>}
                  </Row>
                  <Row>
                    <h3 className="mr-2">Money to bring to the shop </h3>
                  </Row>
                  {/*<Row>
                    <Table>
                      <thead>
                        <tr>
                          <th>
                            Event
                          </th>
                          <th>
                            Qt.
                          </th>
                          <th>
                            Client Name
                          </th>
                          <th>
                            Total
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {eventList && eventList.map((eventItem)=>{
                          return eventItem.cart.map((cartItem)=>{
                            console.log(cartItem)
                              return (<tr key={uuid()}>
                                <th scope="row">
                                  {cartItem._id.Name}
                                </th>
                                <td>
                                  {cartItem.qt}
                                </td>
                                <td>
                                  {eventItem.clientName}
                                </td>
                                <td>
                                  {cartItem._id.Upfront * cartItem.qt}
                                </td>
                              </tr>)
                              
                            })
                              
                            
                          })
                        }
                      </tbody>
                    </Table>
                  </Row>*/}

                </CardBody>
              </Card>
            </Col>
            {role == 'admin' && <DepositLogs/>}
          </>
                );
  
            }
            
            export default DepositCard;